import * as Styled from './HighlightBox.styles';

export const HighlightBox = ({ children }) => {
  return (
    <Styled.Wrapper>        
        {children}
    </Styled.Wrapper>
  );
};
